import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const CalendarRoutes: RouteBundle = {
  domain: 'calendar',
  routes: [{urlPattern: 'calendar', handler: EditorRoutes.calendar.bind(EditorRoutes), legacy: true}],
};
